const TAWKTO_ENABLED_FLAG = process.env.NEXT_PUBLIC_TAWKTO_ENABLED;
const isExplicitlyEnabled = TAWKTO_ENABLED_FLAG === 'true';
const isExplicitlyDisabled =
  TAWKTO_ENABLED_FLAG !== undefined && TAWKTO_ENABLED_FLAG !== '' && !isExplicitlyEnabled;

export const TAWKTO_ENABLED =
  isExplicitlyEnabled || (!isExplicitlyDisabled && process.env.NODE_ENV === 'production');

export const TAWKTO_SCRIPT_URL =
  process.env.NEXT_PUBLIC_TAWKTO_WIDGET_URL ||
  'https://embed.tawk.to/59007fad4ac4446b24a6c0ff/default';

const chatNavFlag = process.env.NEXT_PUBLIC_TAWKTO_CHAT_NAV_VISIBLE;

/**
 * Show the "Chat with us" nav item when explicitly enabled, or default to the
 * widget enabled state so the trigger is visible wherever the widget is active.
 * Explicitly set the env var to 'false' to keep the widget enabled while hiding
 * the navbar shortcut.
 */
export const TAWKTO_CHAT_NAV_VISIBLE =
  chatNavFlag === 'true' || ((chatNavFlag === undefined || chatNavFlag === '') && TAWKTO_ENABLED);
